import { ReportChartGroupCompareItemType } from '@vision/ui/interfaces';
import React, { useEffect, useState } from 'react';
import {
  ReportsDetailGraphicCompareContentCategory,
  ReportsDetailGraphicCompareUnit,
} from '../../../ReportsDetailGraphicCompareComponents';

interface CompareRendererConfig {
  component: React.FC<{
    compareItemType?: ReportChartGroupCompareItemType;
    required: boolean;
  }>;
  required: boolean;
}

const compareComponentMapping: Partial<Record<ReportChartGroupCompareItemType, CompareRendererConfig>> = {
  'unit-name': {
    component: ReportsDetailGraphicCompareUnit,
    required: false,
  },
  'category-content-name': {
    component: ReportsDetailGraphicCompareContentCategory,
    required: true,
  },
};

interface TreeMapChart2CompareRendererProps {
  compareItemTypes: ReportChartGroupCompareItemType[];
}

export function TreeMapChart2CompareRenderer({ compareItemTypes }: TreeMapChart2CompareRendererProps) {
  const [components, setComponents] = useState<React.JSX.Element[]>([]);

  useEffect(() => {
    const newComponents: React.JSX.Element[] = compareItemTypes.map((compareItemType) => {
      const config = compareComponentMapping[compareItemType];

      if (!config) {
        return null;
      }

      const Component = config.component;

      return <Component key={compareItemType} compareItemType={compareItemType} required={config.required} />;
    });

    setComponents(newComponents);
  }, [compareItemTypes]);

  return <>{components}</>;
}
